import { Helmet } from 'react-helmet-async';

import { paths } from 'src/routes/paths';
import { useSearchParams } from 'src/routes/hooks';

import { MotivationIllustration } from 'src/assets/illustrations';

import { GeneralPageView } from 'src/sections/general/index';

// ----------------------------------------------------------------------

const illustration = <MotivationIllustration sx={{ height: 200, my: { xs: 5, sm: 10 } }} />;

/**
 * The page BigCommerce shows, inside the seller's control panel, once the Voolist app is added. The store isn't
 * connected yet: its button opens Voolist in a new tab, where the seller confirms which store it is
 * (bigcommerce-finish-connect on the Marketplaces page). When adding the app didn't work, or the store waited
 * too long to be connected, it says so.
 */

// Why the store isn't connected, by the reason BigCommerce's callbacks send the seller here with.
const NOT_CONNECTED_BECAUSE = {
  cancelled: "The Voolist app wasn't added. To connect, click Go to Marketplaces, then Connect BigCommerce.",
  timed_out: 'This BigCommerce connection timed out. Remove the Voolist app in BigCommerce, then click Connect BigCommerce in Voolist. Your products stay in your store.',
  failed: "The Voolist app couldn't be added. To try again, click Go to Marketplaces, then Connect BigCommerce.",
};
export default function BigCommerceInstallPage () {
  const searchParams = useSearchParams();
  const code = searchParams.get('code');
  const notConnectedBecause = NOT_CONNECTED_BECAUSE[searchParams.get('error')] || NOT_CONNECTED_BECAUSE.failed;

  return (
    <>
      <Helmet>
        <title>Connect BigCommerce</title>
      </Helmet>

      {code ? (
        <GeneralPageView
          header="One more step"
          subheader="Click Finish connecting. Voolist opens in a new tab, where you confirm your store."
          buttonLabel="Finish connecting"
          buttonHref={`${paths.management.stores}?${new URLSearchParams({ installed: code, platform: 'bigCommerce' })}`}
          illustration={illustration}
        />
      ) : (
        <GeneralPageView
          header="Your store isn't connected"
          subheader={notConnectedBecause}
          buttonLabel="Go to Marketplaces"
          buttonHref={paths.management.stores}
          illustration={illustration}
        />
      )}
    </>
  );
}
